<template>
  <div
  class="NavBarFiles">
    <span
    v-if="isMain"
    class="NavBarFiles__element">
      <span class="NavBarFiles__title">
        Your Files
      </span>
    </span>
    <span
    v-if="folderName"
    class="NavBarFiles__element">
      <router-link
      tag="i"
      class="el-breadcrumb__separator el-icon-back NavBarFiles__back-icon"
      :to="parentPath()"/>
      <span class="NavBarFiles__title">{{folderName}}</span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavBarFiles',

  computed: {
    ...mapGetters('filesFolder', [
      'folderById'
    ]),
    isMain () {
      return this.$route.name === 'files'
    },
    folderId () {
      return this.$route.params.folderId
    },
    folder () {
      return this.folderById(this.folderId)
    },
    folderInfo () {
      return this.folder ? this.folder.folderInfo : {}
    },
    folderName () {
      return this.folderInfo ? this.folderInfo.name : ''
    }
  },

  methods: {
    parentPath () {
      if (this.folderInfo) {
        return {
          path: `/files/${this.folderInfo.parentItemId}`
        }
      } else {
        return {
          path: '/files'
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import 'NavBarFiles';
</style>
